<template>

    <div class="py-3">
        <div class="d-flex justify-content-between mb-3">
            <router-link class="back-route h3" ref="backBtn" @click="backHandler" to="/super/users">
                <font-awesome-icon :icon="['fas', 'angle-left']" size="lg" />
                Create User
            </router-link>
            <SaveBtn @save="submitHandler" />
        </div>

        <div id="createUserContainer" class="tabcontent">
            <form class="form-container row d-flex flex-column justify-content-between">
                <div class="row col-12 inputs-container">
                    <div class="col-md-4">
                        <label for="inputName" class="form-label">Name<span style="color: #E95626">*</span></label>
                        <input type="text" @input="[changeHandler($event, errors, 'name'), setData($event, 'name')]"
                            v-model="userData.name" class="custom-input form-control" id="inputName" placeholder="Name"
                            :style="userData.file != null ? { 'pointerEvents': 'none' } : { 'pointerEvents': 'auto' }">
                        <div class="err" v-if="errors['name'].length > 0">
                            <div v-for="msg in errors['name']" class="text-danger">{{ msg }}</div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label for="inputEmail" class="form-label">Email<span style="color: #E95626">*</span></label>
                        <div class="d-flex flex-nowrap  mb-1">
                            <input type="email"
                                @input="[changeHandler($event, errors, 'email'), setData($event, 'email')]"
                                v-model="userData.email" class="custom-input form-control" id="inputEmail"
                                placeholder="Email@example.com"
                                :style="userData.file != null ? { 'pointerEvents': 'none' } : { 'pointerEvents': 'auto' }">
                            <div class="input-group-append">
                                <span class="input-group-text">@{{ organizationDomain }}</span>
                            </div>
                        </div>
                        <div class="err" v-if="errors['email'].length > 0">
                            <div v-for="msg in errors['email']" class="text-danger">{{ msg }}</div>
                        </div>
                    </div>
                </div>
                <div class="row col-12 d-flex ">
                    <div class="col-md-4 ">
                        <label class="mb-2">Password</label>
                        <input type="password" class="form-control custom-input" v-model="userData.password"
                            @input="[changeHandler($event, errors, 'password'), setData($event, 'password')]"
                            id="password" name="password" placeholder="Enter Password">

                        <div class="err" v-if="errors['password'].length > 0">
                            <div v-for="msg in errors['password']" class="text-danger">{{ msg }}<br></div>
                        </div>
                    </div>
                    <div class="col-md-4 ">
                        <label class="mb-2">Confirm Password</label>
                        <input type="password" class="form-control custom-input"
                            v-model="userData.password_confirmation"
                            @input="[changeHandler($event, errors, 'password_confirmation'), setData($event, 'password_confirmation')]"
                            id="password_confirmation" name="password_confirmation" placeholder="Confirm Password">

                        <div class="err" v-if="errors['password_confirmation'].length > 0">
                            <div v-for="msg in errors['password_confirmation']" class="text-danger">{{ msg }}</div>
                        </div>
                    </div>
                </div>
                <div class="row cssDesignRole col-12">
                    <div class="col-md-4">
                        <Multiselect v-model="userData.roles" :options="userRoles" class="designOfAssign"
                            placeholder="Assign Role to User" />
                    </div>
                </div>

            </form>

            <div v-if="errorMessages.length > 0" class="error-container">
                <div v-for="msg in errorMessages" class="text-danger my-4">{{ msg }}</div>
            </div>
        </div>
    </div>

    <AlartModal v-if="showModal" message="User Created" imagePath="okImage.svg" @close-modal="showModal = false" />
    <AlartModal v-if="showErrorModal" :message="responseErrorMessage" imagePath="close.png"
        @close-modal="showErrorModal = false" />

    <ConfirmationModal v-if="isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
        @close-modal="confirmModalHandler($event)" />
</template>

<script>
import FilePondDemo from '../../components/FilePondDemo';
import Multiselect from '@vueform/multiselect';
import AlartModal from "../../components/AlartModal";
import SaveBtn from '../../components/SaveBtn';
import ConfirmationModal from "../../components/ConfirmationModal";
import User from '../../../api-services/repository';
import repository from "../../../api-services/repository";
import changeHandler from '../../../validation/superUserValidation';
import { computed } from "vue";

export default {
    name: 'user-superCreate',
    components: {
        FilePondDemo,
        Multiselect,
        SaveBtn,
        AlartModal,
        ConfirmationModal
    },
    async mounted() {
        await this.$store.dispatch('activeTap', 'super-users');
        this.getRoles();
    },
    data() {
        return {
            changeHandler,
            ownerID: this.$store.state?.auth?.user ? this.$store.state?.auth?.user.data.id : null,
            showModal: false,
            isFull: false,
            organizationDomain: 'caduceuslane.com',
            showErrorModal: false,
            userRoles: [],
            userData: {
                owner_id: this.ownerID,
                name: '',
                email: '',
                file: null,
                password: null,
                password_confirmation: null,
                roles: ''
            },

            errors: {
                name: [],
                email: [],
                password: [],
                password_confirmation: [],
                isError: false
            },
            isData: {
                name: false,
                email: false,
                password: false,
                password_confirmation: false,
                file: false
            },
            errorMessages: [],
            responseErrorMessage: '',
            isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
            confirmModal: computed(() => this.$store.state.settings.confirmModal),
            confirmMessage: computed(() => this.$store.state.settings.confirmMessage)
        }
    },
    methods: {
        async viewDocumentHandler(e, filePath) {
            const link = document.createElement("a");
            link.href = "https://dk703uarlyapi.cloudfront.net/users-demo.xlsx";
            link.download = "users_demo.xlsx";
            link.click();
        },
        async backHandler() {
            let setDataFlag = this.$store.state.settings.setDataFlag;
            if (setDataFlag) {
                this.isFull = true;
                await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
            } else {
                await this.$store.dispatch('setDataFlag', false);
                this.isFull = false
            }
        },
        fileUpload(event) {
            this.userData.file = event;
            this.setData(true, 'file');
        },
        fileRemove(event) {
            this.userData.file = null;
            this.setData('', 'file');
        },
        setData(e, type) {
            let val = type !== 'file' ? e.target.value : e;
            let uploadFile = document.getElementsByClassName('upload-file');

            if (val !== '') {
                this.isData[type] = true;

                if (type === 'file') {
                    this.errors['name'] = [];
                    this.errors['email'] = [];
                    this.errors['password'] = [];
                    this.errors['password_confirmation'] = [];
                }
            } else {
                this.isData[type] = false;
            }

            if (this.isData[type]) {
                this.$store.dispatch('setDataFlag', true);
            } else {
                this.$store.dispatch('setDataFlag', false);
            }
        },
        async confirmModalHandler(event) {
            this.isFull = false;
            await this.$store.dispatch('setConfirmModal', false);
            if (event) {
                await this.$store.dispatch('setDataFlag', false);
                // await this.$router.push('/roles');
                await this.$router.push('/' + this.$store.state.settings.currentRoute);
            }
        },
        async getRoles() {
            const response = await repository.getRoles();
            for (let i = 0; i < response.data.data.length; i++) {
                this.userRoles.push({ label: response.data.data[i].name, value: response.data.data[i].name });
            }
        },
         areAllErrorsEmpty() {
            if (!this.errors) return true;

            const { isError, ...errorArrays } = this.errors;
            return !isError && Object.keys(errorArrays).every(key => errorArrays[key].length === 0)
        },
        async submitHandler() {
            this.errorMessages = [];
            const data = new FormData();
            console.log(this.areAllErrorsEmpty())

            if (!this.areAllErrorsEmpty()) {

                return false
            }
            data.append('created_by', this.userData.owner_id);
            data.append('name', this.userData.name);
            data.append('password', this.userData.password);
            data.append('password_confirmation', this.userData.password_confirmation);
            data.append('email', this.userData.email + ('@' + this.organizationDomain));
            data.append('role', this.userData.roles);

            try {
                if (this.userData.file == null) {
                    if (this.userData.name === '') {
                        this.errors.isError = true;
                        this.errors['name'][0] = '*Required';
                    }
                    if (this.userData.email === '') {
                        this.errors.isError = true;
                        this.errors['email'][0] = '*Required';
                    }
                    if (this.userData.password == null) {
                        this.errors.isError = true;
                        this.errors['password'][0] = '*Required';
                    }
                    if (this.userData.password_confirmation == null) {
                        this.errors.isError = true;
                        this.errors['password_confirmation'][0] = '*Required';
                    }
                }
                if (this.userData.roles === '') {
                    this.showErrorModal = true;
                    this.responseErrorMessage = "Please Select a Role to Assign to Users";

                }
                if (this.userData.password == null) {
                    this.errors.isError = true;
                    this.errors['password'][0] = '*Required';
                }
                if (this.userData.password_confirmation == null) {
                    this.errors.isError = true;
                    this.errors['password_confirmation'][0] = '*Required';
                }
                else {

                    if (!this.errors.isError) {
                        const cretedUser = await User.saveUser(data);
                        let closeFileBtn = document.getElementsByClassName('filepond--action-remove-item');
                        closeFileBtn[0]?.click();
                        await this.$store.dispatch('setSuccessModal', true);
                        await this.$store.dispatch('setSueccessMessage', cretedUser.data.message);

                        this.userData.name = '';
                        this.userData.email = '';
                        this.userData.password = null;
                        this.userData.password_confirmation = null;
                        this.userData.file = null;
                        this.userData.roles = '';
                        await this.$store.dispatch('setDataFlag', false);
                        this.errors = {
                            name: [],
                            email: [],
                            password: [],
                            password_confirmation: [],
                            isError: false
                        };

                        setTimeout(() => {
                            this.$router.push({ name: 'user-superIndex' });
                        }, 1000);
                    }
                }
            } catch (e) {
                console.log({ e })
                if (e.response.data.errors) {
                    if (e.response.data.errors.name || e.response.data.errors.email || e.response.data.errors.password || e.response.data.errors.password_confirmation) {
                        if (e.response.data.errors.name)
                            e.response.data.errors.name.forEach((err, idx) => {
                                this.errors['name'][idx] = `*${err}`
                            });
                        if (e.response.data.errors.email)
                            e.response.data.errors.email.forEach((err, idx) => {
                                this.errors['email'][idx] = `*${err}`
                            });
                        if (e.response.data.errors.password)
                            e.response.data.errors.password.forEach((err, idx) => {
                                this.errors['password'][idx] = `*${err}`
                            });
                        if (e.response.data.errors.password_confirmation)
                            e.response.data.errors.password_confirmation.forEach((err, idx) => {
                                this.errors['password_confirmation'][idx] = `*${err}`
                            });
                    } else if (e.response.data.errors.file) {
                        this.errorMessages[0] = `* ${e.response.data.errors.file[0]}`;
                    } else {
                        let idx = 0;
                        for (const property in e.response.data.errors) {
                            let key = property.split('.')[1];
                            let record = property.split('.')[0]
                            console.log(`record ${+record + 1}: ${e.response.data.errors[property]}`);

                            this.errors[key][idx++] = `*record ${+record + 1}: ${e.response.data.errors[property]}` + '\n';
                        }
                    }
                } else if (e.response.data) {
                    this.showErrorModal = true;
                    this.responseErrorMessage = e.response.data.message
                }
            }

        }
    }
}
</script>

<style scoped>
.input-group-text {
    height: 36px;
    background-color: var(--background-color-input-create);
    color: var(--main-color);
}

.cssGap {
    gap: 20px;
}

.cssDesignRole {
    position: relative;
    right: 16px;
}

.hrAll {
    display: flex;
    width: 97%;
}

.textH5 {
    display: flex;
    justify-content: center;
    align-items: center;
}

.designOfAssign {
    background-color: var(--background-color-input-create);
    color: var(--main-color);
    position: relative;
    left: 18px;
    width: 99%;
}

.err {
    overflow-y: auto;
    min-height: 30px;
    max-height: 170px;
}

.custom-input,
.custom-input:focus {
    background-color: var(--background-color-input-create);
    color: var(--main-color);
}

#createUserContainer {
    padding: 20px;
    height: 70vh;
}


.upload-file {
    background-color: #021A24;
    border: 1px solid #6F8896;
    z-index: 0;
    width: 100%;
    border-radius: 15px;
    padding: 10%;
    overflow-y: auto;
    display: flex;
}

.upload-file2 {
    background-color: #021A24;
    border: 1px solid #6F8896;
    z-index: 0;
    width: 100%;
    border-radius: 15px;
    padding: 10%;
    overflow-y: auto;
}

.form-container {
    gap: 20px;
}

.error-container {
    max-height: 250px;
    min-height: 10px;
    height: 90px;
    padding: 10px;
    margin-top: 40px;
    overflow-y: auto;
}

.inputs-container {
    height: 80px;
}
</style>